import React, {Component} from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import {Button} from "react-bootstrap";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import * as Constants from "../constants/Constants";
const strings = require('../resources/strings.json');


 export default class BuildsTable extends Component {

    constructor(props) {
        super(props);
        this.deleteBuild = this.deleteBuild.bind(this);
        this.getTrProps = this.getTrProps.bind(this);
    }

    state = {
        data: [],
        areaDevices: [],
        deleteBuildVersion: {},
        show: false
    };

    columns = [
        {
            Header: "Version",
            accessor: "version",
            width: 80
        },
        {
            Header: "URL",
            accessor: "buildUrl",
        },
        {
            Header: "Type",
            accessor: "firmwareType",
            width: 150
        },
        {
            Header: "Added on",
            accessor: "addedOn",
            width: 200
        },
        {
            Header: 'Actions',
            id: 'upgrade-button',
            Cell: (row) => (
                <Button variant="danger" onClick={()=>{
                this.setState({show: true,
                    deleteBuildVersion: this.state.data[row.index] })
            }}><FontAwesomeIcon icon={faTimes} /></Button> ),
            width: 80
        }
    ];

    componentDidMount() {
        this.getBuildListForDisplay();
    }
  

    componentDidUpdate(prevProps) {
		if(this.props !== prevProps && this.props.build !== null ){
            this.getBuildListForDisplay();
        }
    }

    getBuildListForDisplay() {
        let data = [];
        for (let i = 0; i < this.props.build.length; i++) {
            let buildData = this.props.build[i];
            let build = {};
            build.buildUrl = buildData.buildUrl;
            switch(buildData.firmwareType){
                case Constants.FIRMWARE_TYPE.SWITCH_DEVICE_IMAGE: {
                    build.firmwareType = strings.switchFirmwareBuild;
                    break;
                }
                case Constants.FIRMWARE_TYPE.SWITCH_STM_IMAGE: {
                    build.firmwareType = strings.switchImageBuild;
                    break;
                }
                case Constants.FIRMWARE_TYPE.WIFI_IMAGE: {
                    build.firmwareType = strings.wifiImage;
                    break;
                }
                case Constants.FIRMWARE_TYPE.PCB_IMAGE: {
                    build.firmwareType = strings.pacImageBuild;
                    break;
                }
                case Constants.FIRMWARE_TYPE.AC_IMAGE: {
                    build.firmwareType = strings.pacFirmwareBuild;
                    break;
                }
                default: {
                    build.firmwareType = strings.switchFirmwareBuild;
                    break;
                }
            }    
            var date = new Date(buildData.addedOn);
            build.addedOn = date.toLocaleString();
            build.version = buildData.major + "." + buildData.minor + "." + buildData.revision;
            build.isGoldenBuild = buildData.goldenBuild;
            data.push(build);
        }
        this.setState({data: data});
    }

    async deleteBuild () {
        const deleteBuildVersion = this.state.deleteBuildVersion
        this.setState({show: false,  deleteBuildVersion: {}})
        await this.props.deleteBuild(deleteBuildVersion);
    }

    getTrProps = (state, rowInfo, instance) => {
        if (rowInfo) {
          return {
            style: {
              background: rowInfo &&
              rowInfo.original.isGoldenBuild &&
              "lavender"
            }
          };
        }
        return {};
      };

    
    render() {
        return (
            <div>
            <ReactTable
                columns={this.columns}
                data={this.state.data}
                className="-striped -highlight"
                defaultPageSize={20}
                sortable={false}
                defaultSorted={[
                    { id: "version", desc: true },
                  ]}
                getTrProps={this.getTrProps}
            />
            <Modal open={this.state.show} onClose={() => this.setState({show: false, deleteBuildVersion: {}})} center>
            <h2>Are you sure ?</h2>
            <hr/>
            <br/>
            <p>
             Are you sure you want to delete {this.state.deleteBuildVersion.version} build ?
            </p>
            <br/>
            <Button variant="secondary" onClick={() => this.setState({show: false,  deleteBuildVersion: {}})}>Cancel</Button>
            <Button variant="primary" onClick={() => this.deleteBuild( )}>Delete</Button>
          </Modal>
            </div>
        )
    }
}
